import FormHelpText from './FormHelpText';

// export types
export type { FormHelpTextProps } from './FormHelpText';

// export components
export { FormHelpText };
export default FormHelpText;
